const fundingTypesOrders = [
  "Pre-Seed",
  "Seed",
  "Pre-Seed to Seed",
  "Pre-Series A",
  "Series A",
  "Series B",
  "Series C",
  "Series D",
  "Series E",
  "Series F",
  "Series G",
  "Series H",
  "Series I",
  "Series J",
  "Late Stage",
  "PE Round",
  "Pre-IPO",
  "ICO",
  "Grant",
  "Debt Financing",
  "Others",
  "No longer active",
];

export default fundingTypesOrders;

export const orderFundingTypes = (inputArray) => {
  return inputArray.sort((a, b) => {
    return fundingTypesOrders.indexOf(a) - fundingTypesOrders.indexOf(b);
  });
};

export const orderFundingTypesInObject = (inputArray) => {
  return inputArray.sort((a, b) => {
    if (a.name === "Others") return 1; // "Others" should come after all other items
    if (b.name === "Others") return -1; // "Others" should come after all other items
    return b.total_amount - a.total_amount; // Sort by total_amount in descending order
  });
  //   return inputArray.sort((a, b) => {
  //     return fundingTypesOrders.indexOf(a.name) - fundingTypesOrders.indexOf(b.name);
  //   });
};
